module.exports = __webpack_public_path__ + "img/profile-cover.e82b5228.jpg";